export enum RequestType {
	Get = 'get',
	Put = 'put',
	Post = 'post',
	Delete = 'delete',
	Patch = 'patch',
}
